import { usePath } from '../shared/router.ts';
import { Splash } from './Splash.tsx';
import { Gallery } from './Gallery.tsx';

/**
 * Two screens. The gallery owns /g and /g/:assetId so a client can send
 * someone a link straight to one photograph -- which still requires their
 * session cookie to render anything.
 */
export function App(): React.JSX.Element {
  const path = usePath();

  return path.startsWith('/g') ? <Gallery /> : <Splash />;
}
